module.exports = __webpack_public_path__ + "static/media/UA.e683d4d5.svg";